import React from 'react';

export default function SymbolText({ symbol }) {
    if (symbol == undefined) {
        return null;
    }
    return <div style={{marginBottom: 10}}>{symbol === 'or' ? '或者' : '并且'}</div>;
};



// WEBPACK FOOTER //
// ./src/components/user/fieldLeader/components/SymbolText.js